export enum RefundStatus {
  Failed = 'Failed',
  Succeeded = 'Succeeded',
  Pending = 'Pending',
  CustomCode = 'CustomCode',
}
